var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Carousel'),_c('MainTitle'),_c('KnowUSoon'),_c('Service',{attrs:{"isIndex":""}}),_c('OurTeam'),_c('ContactUs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }